import { PaginatedRoomsParams } from "./paginated-rooms.models";
import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { roomListKey } from "../room-query-keys";
import { UrlHelper } from "@/lib/helpers";

export function useQueryGetPaginatedRooms(queryProps: PaginatedRoomsParams) {
  const paramsURL = UrlHelper.buildPaginatedParams(queryProps);
  const { isLoading, data, isError, isPlaceholderData } = useQueryWrapper({
    queryKey: [...roomListKey(), paramsURL],
    queryFn: () => API.Rooms.getPaginatedRooms(paramsURL),
    placeholderData: true,
    refetchInterval: 1000 * 60 * 1,
  });
  return {
    isLoading,
    isPlaceholderData,
    rooms: data?.rooms || [],
    totalRooms: data?.totalRooms || 0,
    totalPages: data?.totalPages || 0,
    isError,
  };
}
